import React from "react";
import Layout from "../components/Layout";
import SEOHead from "../components/SEOHead";
import PageHeader from "../components/PageHeader";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Check } from "lucide-react";

const TIERS = [
  { name: "Pilot — 60 Days", price: "Complimentary",
    audience: "Single city/county/agency",
    features: [
      "Up to 3 budget documents analyzed",
      "1 infrastructure risk dashboard",
      "Cybersecurity readiness snapshot",
      "Executive briefing deck",
    ], cta: "Apply for Pilot" },
  { name: "Civic", price: "Tiered by population",
    audience: "Cities & counties",
    features: [
      "Full budget scanner + AI analysis",
      "Infrastructure + vendor dashboards",
      "Community benefit reports",
      "Quarterly transparency scorecard",
    ], cta: "Request Civic Pricing", highlight: true },
  { name: "CyberWater",  price: "Per-facility",
    audience: "Data centers & utilities",
    features: [
      "PLC/SCADA/AWG protection",
      "Device trust + sensor integrity",
      "Multi-party command authorization",
      "24/7 AI monitor + incident workflow",
    ], cta: "Scope CyberWater" },
];

const Pricing = () => (
  <Layout>
    <SEOHead title="Pricing & Pilot Program | AuditIQ" path="/pricing"
      description="AuditIQ pricing and pilot program tiers for cities, counties, data centers, and utilities." />
    <PageHeader eyebrow="Pricing · Pilot" title="Start with a pilot. Scale on results."
      subtitle="Every engagement begins with a 60-day pilot so your leadership can evaluate AuditIQ against real public-sector questions." />
    <section className="container-x section-y grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
      {TIERS.map(t => (
        <div key={t.name} className={`panel-elev card-premium flex flex-col ${t.highlight ? "border-gold" : ""}`}>
          {t.highlight && <div className="text-[11px] uppercase tracking-[0.26em] text-gold mb-3">Most Requested</div>}
          <h3 className="font-display">{t.name}</h3>
          <div className="price-figure mt-3">{t.price}</div>
          <div className="text-sm text-steel mt-2">{t.audience}</div>
          <ul className="mt-7 space-y-3">
            {t.features.map(f => (
              <li key={f} className="flex items-start gap-2 text-cream-dim">
                <Check size={18} className="text-gold mt-1 shrink-0" />{f}
              </li>
            ))}
          </ul>
          <Link to="/contact" className="mt-auto pt-7 block"><Button className={`h-12 w-full ${t.highlight ? "btn-gold" : "btn-ghost-gold"}`}
            data-testid={`pricing-${t.name.split(' ')[0].toLowerCase()}`}>
            {t.cta}
          </Button></Link>
        </div>
      ))}
    </section>
  </Layout>
);

export default Pricing;
